module.exports = __webpack_public_path__ + "img/symbol_amor@2x.b5da9a1.jpg";